import { TimeDropdown } from '@/components/dropdown/selectTimeDropdown';
import Utils from '@/utils/util';
import React, { ChangeEvent, useEffect, useState, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { Hours } from '../types';
import { ActionMenu } from '@/components/Elements/ActionMenu';
import { ReactComponent as ActionAdd } from '@/assets/img/action-add.svg';
import { ReactComponent as ActionDelete } from '@/assets/img/action-delete.svg';
import { ReactComponent as ActionCopy } from '@/assets/img/action-copy.svg';

import { isBrowser, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { number } from 'yargs';
import { UserContext } from '@/routes';
type ConfigureBusinessHoursProps = {
  hours: any;
  onChange?: (hours: BusinessHoursItem[]) => any;
  readOnly?: boolean;
};
export type BusinessHoursItem = {
  day: number;
  perDayOpenHours: Hours[];
};
export const ConfigureBusinessHours = ({
  hours,
  onChange,
  readOnly = false,
}: ConfigureBusinessHoursProps) => {
  const { t, i18n } = useTranslation();
  const timeStamp = [
    { label: '12:00 AM', value: '00:00:00', isSelected: false },
    { label: '00:30 AM', value: '00:30:00', isSelected: false },
    { label: '01:00 AM', value: '01:00:00', isSelected: false },
    { label: '01:30 AM', value: '01:30:00', isSelected: false },
    { label: '02:00 AM', value: '02:00:00', isSelected: false },
    { label: '02:30 AM', value: '02:30:00', isSelected: false },
    { label: '03:00 AM', value: '03:00:00', isSelected: false },
    { label: '03:30 AM', value: '03:30:00', isSelected: false },
    { label: '04:00 AM', value: '04:00:00', isSelected: false },
    { label: '04:30 AM', value: '04:30:00', isSelected: false },
    { label: '05:00 AM', value: '05:00:00', isSelected: false },
    { label: '05:30 AM', value: '05:30:00', isSelected: false },
    { label: '06:00 AM', value: '06:00:00', isSelected: false },
    { label: '06:30 AM', value: '06:30:00', isSelected: false },
    { label: '07:00 AM', value: '07:00:00', isSelected: false },
    { label: '07:30 AM', value: '07:30:00', isSelected: false },
    { label: '08:00 AM', value: '08:00:00', isSelected: false },
    { label: '08:30 AM', value: '08:30:00', isSelected: false },
    { label: '09:00 AM', value: '09:00:00', isSelected: false },
    { label: '09:30 AM', value: '09:30:00', isSelected: false },
    { label: '10:00 AM', value: '10:00:00', isSelected: false },
    { label: '10:30 AM', value: '10:30:00', isSelected: false },
    { label: '11:00 AM', value: '11:00:00', isSelected: false },
    { label: '11:30 AM', value: '11:30:00', isSelected: false },
    { label: '12:00 PM', value: '12:00:00', isSelected: false },
    { label: '12:30 PM', value: '12:30:00', isSelected: false },
    { label: '01:00 PM', value: '13:00:00', isSelected: false },
    { label: '01:30 PM', value: '13:30:00', isSelected: false },
    { label: '02:00 PM', value: '14:00:00', isSelected: false },
    { label: '02:30 PM', value: '14:30:00', isSelected: false },
    { label: '03:00 PM', value: '15:00:00', isSelected: false },
    { label: '03:30 PM', value: '15:30:00', isSelected: false },
    { label: '04:00 PM', value: '16:00:00', isSelected: false },
    { label: '04:30 PM', value: '16:30:00', isSelected: false },
    { label: '05:00 PM', value: '17:00:00', isSelected: false },
    { label: '05:30 PM', value: '17:30:00', isSelected: false },
    { label: '06:00 PM', value: '18:00:00', isSelected: false },
    { label: '06:30 PM', value: '18:30:00', isSelected: false },
    { label: '07:00 PM', value: '19:00:00', isSelected: false },
    { label: '07:30 PM', value: '19:30:00', isSelected: false },
    { label: '08:00 PM', value: '20:00:00', isSelected: false },
    { label: '08:30 PM', value: '20:30:00', isSelected: false },
    { label: '09:00 PM', value: '21:00:00', isSelected: false },
    { label: '09:30 PM', value: '21:30:00', isSelected: false },
    { label: '10:00 PM', value: '22:00:00', isSelected: false },
    { label: '10:30 PM', value: '22:30:00', isSelected: false },
    { label: '11:00 PM', value: '23:00:00', isSelected: false },
    { label: '11:30 PM', value: '23:30:00', isSelected: false },
  ];
  const [businessHours, setBusinessHours] = useState<any>([]);
  const userContext = useContext(UserContext);
  useEffect(() => {
    const map = new Map();
    map.set(1, []);
    map.set(2, []);
    map.set(3, []);
    map.set(4, []);
    map.set(5, []);
    map.set(6, []);
    map.set(7, []);

    if (hours) {
      hours?.map((item: Hours) => {
        const alreadyExistedData = map.get(item.day);
        if (alreadyExistedData) {
          alreadyExistedData.push({ ...item });
        } else {
          map.set(item.day, [{ ...item }]);
        }
      });
    }
    const arr = [];
    for (const [key, value] of map) {
      arr.push({ day: key, perDayOpenHours: value });
    }

    setBusinessHours(arr);
  }, [hours]);

  // useEffect(() => {
  //   onChange(businessHours);
  // }, [businessHours]);

  const updateBusinessHoursss = (hours: any) => {
    setBusinessHours(hours);
    onChange && onChange(hours);
  };

  const addNewBusinessHours = async (item: any, isAdd: boolean) => {
    if (isAdd) {
      const perDayOpenHours = {
        openTime: '00:00:00',
        closeTime: '00:00:00',
        day: item?.day,
      };
      item.perDayOpenHours.push(perDayOpenHours);
    } else {
      item.perDayOpenHours = [];
    }
    updateBusinessHoursss([...businessHours]);
  };
  const updateBusinessHours = (
    value: string | null,
    day: number | undefined,
    time: string,
    index1: number
  ) => {
    const updatedDataArray = businessHours.map((item: BusinessHoursItem) => {
      if (item.day === day && time === 'openTime') {
        return {
          ...item,
          perDayOpenHours: item.perDayOpenHours.map((obj: any, index: any) => {
            if (index === index1) {
              return { ...obj, openTime: value };
            }
            return obj;
          }),
        };
      }
      if (item.day === day && time === 'closeTime') {
        return {
          ...item,
          perDayOpenHours: item.perDayOpenHours.map((obj: any, index: any) => {
            if (index === index1) {
              return { ...obj, closeTime: value };
            }
            return obj;
          }),
        };
      }
      return item;
    });
    updateBusinessHoursss([...updatedDataArray]);
  };
  const removeBusinessHours = (bh: any) => {
    if (hours) {
      bh.perDayOpenHours = [];
      updateBusinessHoursss([...businessHours]);
    }
  };

  const applyToAll = (bh: any) => {
    businessHours.forEach((bhitem: any, index: number) => {
      bhitem.perDayOpenHours = JSON.parse(JSON.stringify(bh.perDayOpenHours));
      bhitem.perDayOpenHours.forEach((element: any) => {
        element.day = index + 1;
      });
    });
    updateBusinessHoursss([...businessHours]);
  };

  const getActions = (event: any) => {
    const optionArray = [];
    if (event) {
      optionArray.push({
        label: t('Add interval'),
        icon: ActionAdd,
        onClickHandler: () => {
          addNewBusinessHours(event, true);
        },
        itemClassName: '',
      });
    }
    optionArray.push({
      label: t('Apply to all'),
      icon: ActionCopy,
      onClickHandler: () => {
        applyToAll(event);
      },
      itemClassName: 'delete-red',
    });
    if (
      event &&
      event.perDayOpenHours &&
      event.perDayOpenHours.length > 0 &&
      event.perDayOpenHours[0].openTime
    ) {
      optionArray.push({
        label: t('Remove'),
        icon: ActionDelete,
        onClickHandler: () => {
          removeBusinessHours(event);
        },
        itemClassName: 'delete-red font-red',
      });
    }

    return optionArray && optionArray.length > 0 ? optionArray : [];
  };
  const onTimeSelectionChange = (value: string, day: number, time: string, index: number) => {
    updateBusinessHours(value, day, time, index);
  };

  return readOnly ? (
    <div className="default-config">
      <ul>
        {businessHours?.map((item: BusinessHoursItem, index: number) => {
          const { perDayOpenHours, day } = item;
          const isClosed = perDayOpenHours && perDayOpenHours.length > 0;
          return (
            <li>
              <span className={`day ${isClosed ? '' : 'closed'}`}>{Utils.getDay(day)}</span>
              <span className="opening-hours">
                {isClosed ? (
                  <>
                    {perDayOpenHours.map((oh, index) => {
                      const openTime = timeStamp.find((ts) => ts.value === oh.openTime);
                      const closeTime = timeStamp.find((ts) => ts.value === oh.closeTime);
                      return (
                        <>
                          <p key={'oh-' + index}>
                            {openTime?.label} - {closeTime?.label}
                          </p>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <>{`${t('Closed')}`}</>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  ) : (
    businessHours?.map((item: BusinessHoursItem, index: number) => {
      const { perDayOpenHours, day } = item;
      {
        return userContext && userContext?.isLandscape ? (
          <div key={`day-${index}`} className="time-row-outer outer-height">
            <div
              className={`time-row ${
                !perDayOpenHours || perDayOpenHours.length < 1 ? 'close-day' : ''
              }`}
            >
              <div className="day-title">
                <div className="day-title">
                  <Form.Check
                    type="switch"
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      addNewBusinessHours(item, event?.target.checked);
                    }}
                    checked={!perDayOpenHours || perDayOpenHours.length < 1 ? false : true}
                  />
                  <div
                    className={`day-name ${
                      !perDayOpenHours || perDayOpenHours.length < 1 ? 'disable-day' : ''
                    }`}
                  >
                    {Utils.getDay(day)}
                  </div>
                </div>
              </div>
              <div
                className={`time-title ${
                  !perDayOpenHours || perDayOpenHours.length < 1 ? '' : 'pl'
                }`}
              >
                {item?.perDayOpenHours?.map((bh, index) => {
                  return (
                    <div className="time-drp-tab">
                      <TimeDropdown
                        data={timeStamp}
                        selectedValue={`${Utils.getAMPMtime(bh.openTime)}`}
                        onSelect={(value) => {
                          updateBusinessHours(value?.value, item.day, 'openTime', index);
                        }}
                        onDismiss={() => {}}
                      />
                      <span className="pet-sheperator"></span>

                      <TimeDropdown
                        data={timeStamp}
                        selectedValue={`${Utils.getAMPMtime(bh.closeTime)}`}
                        onSelect={(value) => {
                          updateBusinessHours(value?.value, day, 'closeTime', index);
                        }}
                        onDismiss={() => {}}
                      />
                    </div>
                  );
                })}
                {!perDayOpenHours || perDayOpenHours.length < 1 ? (
                  <div className="closed">{`${t('Closed')}`}</div>
                ) : null}
              </div>

              <div className="drop-down-title">
                <ActionMenu options={getActions(item)} />
              </div>
            </div>
          </div>
        ) : (
          <>
            {' '}
            <div key={`day-${index}`} className="time-row-outer outer-height">
              <div
                className={`time-row ${
                  !perDayOpenHours || perDayOpenHours.length < 1 ? 'close-day' : ''
                }`}
              >
                <div className="mobile-action-div">
                  <div className="day-title">
                    <div className="day-title">
                      <Form.Check
                        type="switch"
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          addNewBusinessHours(item, event?.target.checked);
                        }}
                        checked={!perDayOpenHours || perDayOpenHours.length < 1 ? false : true}
                      />
                      <div
                        className={`day-name ${
                          !perDayOpenHours || perDayOpenHours.length < 1 ? 'disable-day' : ''
                        }`}
                      >
                        {Utils.getDay(day)}
                      </div>
                    </div>
                  </div>

                  <div className="drop-down-title">
                    <ActionMenu options={getActions(item)} />
                  </div>
                </div>
                <div
                  className={`time-title ${
                    !perDayOpenHours || perDayOpenHours.length < 1 ? '' : 'pl'
                  }`}
                >
                  {item?.perDayOpenHours?.map((bh, index) => {
                    return (
                      <div className="time-drp-tab">
                        <TimeDropdown
                          data={timeStamp}
                          selectedValue={`${Utils.getAMPMtime(bh.openTime)}`}
                          onSelect={(value) => {
                            updateBusinessHours(value?.value, item.day, 'openTime', index);
                          }}
                          onDismiss={() => {}}
                        />
                        <span className="pet-sheperator"></span>

                        <TimeDropdown
                          data={timeStamp}
                          selectedValue={`${Utils.getAMPMtime(bh.closeTime)}`}
                          onSelect={(value) => {
                            updateBusinessHours(value?.value, day, 'closeTime', index);
                          }}
                          onDismiss={() => {}}
                        />
                      </div>
                    );
                  })}
                  {!perDayOpenHours || perDayOpenHours.length < 1 ? (
                    <div className="closed">{`${t('Closed')}`}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        );
      }
    })
  );
};
{
  /*
  
  <li>
    <span className="day">{Utils.getDay(day)}</span>
    <span className="opening-hours">10:00 AM - 12:00 AM</span>
  </li>
  <li>
    <span className="day">{Utils.getDay(day)}</span>
    <span className="opening-hours">10:00 AM - 12:00 AM</span>
  </li>
  <li>
    <span className="day">{Utils.getDay(day)}</span>
    <span className="opening-hours closed">Closed</span>
  </li>
</ul>
</div> */
}
type TimeSelectionComponentProps = {
  bhItem: BusinessHoursItem;
  bh: Hours;
  index: number;
  onChange: (value: string, day: number, time: string, index: number) => any;
};
